import React from 'react';
import { Link } from "react-router-dom";
import "./jet.css";
import { FaWater, FaShip, FaMapMarkedAlt } from "react-icons/fa";

function JetSkiing() {
  const jetSpots = [
    { name: "Bentota Beach", highlight: "Popular for thrilling jet ski rides", image: "/benthota.webp" },
    { name: "Negombo Lagoon", highlight: "Smooth waters perfect for beginners", image: "/negombo.jpg" },
    { name: "Passikudah", highlight: "Crystal-clear shallow waters", image: "/pasi.jpg" },
  ];

  return (
    <div className="bird-page">
      {/* Banner */}
      <div className="banner-section">
        <img src="/jet-ski.jpg" alt="Jet Skiing" className="banner-image" />
        <div className="banner-content">
          <h1 className="banner-title"><span><b>Jet</b></span> Skiing</h1>
          <div className="banner-description">
            <p>Speed across Sri Lanka’s beautiful waters on a jet ski. Perfect for adrenaline junkies and water sports lovers.</p>
            <Link to="/booking"><button className="book-now-btn">Book Your Jet Ski Ride</button></Link>
          </div>
        </div>
      </div>

      {/* Locations */}
      <div className="wildlife-areas-section">
        <h2 className="section-title">Top Jet Ski Spots</h2>
        <p className="section-subtitle">Experience the thrill</p>
        <div className="wildlife-areas-grid">
          {jetSpots.map((spot, i) => (
            <div className="wildlife-area-card" key={i}>
              <div className="area-image-container">
                <img src={spot.image} alt={spot.name} className="area-image" loading="lazy" />
                <div className="area-overlay"></div>
              </div>
              <div className="area-info">
                <h3>{spot.name}</h3>
                <p>{spot.highlight}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Info Cards */}
      <section className="info-section">
        <div className="info-card"><FaWater className="icon" /><h3 className="desc-heading">High-Speed Rides</h3><p className="desc-para">Feel the rush as you glide across the waves.</p></div>
        <div className="info-card"><FaShip className="icon" /><h3 className="desc-heading">Safe Equipment</h3><p className="desc-para">Well-maintained jet skis for safety and fun.</p></div>
        <div className="info-card"><FaMapMarkedAlt className="icon" /><h3 className="desc-heading">Top Beaches</h3><p className="desc-para">Ride in Sri Lanka’s most scenic beaches.</p></div>
      </section>

      {/* Quote */}
      <section className="quote-section">
        <blockquote>"Life is better on the water."</blockquote>
        {/* <cite>— Unknown</cite> */}
      </section>
    </div>
  );
}

export default JetSkiing;
